import "./NewWebsiteNotice.css";

const NEW_WEBSITE_URL = "https://studyaiplacement.snehachievers.in/";

export default function NewWebsiteNotice() {
  const hostname = window.location.hostname.toLowerCase();

  const isOldWebsite =
    hostname === "snehachievers.in" ||
    hostname === "www.snehachievers.in";

  if (!isOldWebsite) {
    return null;
  }

  return (
    <div className="new-website-notice">
      <div className="new-website-notice-card">
        <div className="new-website-notice-badge">
          StudyAIPlacement
        </div>

        <h1>We Have Moved to Our New Website</h1>

        <p>
          Our new StudyAIPlacement platform is now available with the
          latest information about our career program, study roadmap,
          counselling, admissions and student services.
        </p>

        <a
          className="new-website-notice-button"
          href={NEW_WEBSITE_URL}
        >
          Open New Website
          <span aria-hidden="true">→</span>
        </a>

        <a
          className="new-website-notice-url"
          href={NEW_WEBSITE_URL}
        >
          studyaiplacement.snehachievers.in
        </a>

        <div className="new-website-notice-footer">
          SnehAchievers Tech AI Pvt. Ltd.
        </div>
      </div>
    </div>
  );
}
